import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ODataServiceFactory } from '@common/odata';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ArchivePasswordService {
  private readonly http = inject(HttpClient);
  private readonly odataFactory = inject(ODataServiceFactory);

  /*
   * Global method
   * Use for setting password to archived files
   */
  exportSettings(id: string, password: string): Observable<void> {
    const odataService = this.odataFactory.CreateService(`/ExportSettings(${id})/ArchivePassword`);

    return this.http.put<void>(odataService.Query().GetUrl(), { password });
  }
}
